<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <CouponForBundleCreateAndUpdateFormItems
            :form="form" />
    </VForm>
</template>
<script>
import { rootActions } from '@/store/types'
import VForm from '@/components/VForm.vue'
import CouponForBundleCreateAndUpdateFormItems from '@/components/CouponForBundleCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        CouponForBundleCreateAndUpdateFormItems,
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.ADD_COUPON_FOR_BUNDLE, { ...values },
            )
            return res
        },
    },
}
</script>
